import React from 'react';
import { useRouteError } from 'react-router-dom';

const ErrorLayout = ({ status, routerMatchError }) => {
  return (
    <div>
      <h2 style={{ color: '#EA664D' }}>{status > 0 && `Error (${status})`}</h2>
      <p style={{ color: '#F5F1EE' }}>
        {status == 401 && 'Unauthorized'}
        {status == 404 && 'Unable to find record'}
        {status == 500 && 'Something unexpected happened...'}
        {routerMatchError && "Page doesn't seem to exist..."}
      </p>
      <button onClick={() => history.back()}>Back</button>
      <button onClick={() => location.assign('/manage')}>Home</button>
    </div>
  );
};

// RoR component for use with errors.html.erb (rails-caught errors)
const ErrorPage = (props, railsContext) => {
  const { status } = props.error || 0;
  return () => <ErrorLayout status={status} routerMatchError={false} />;
};

// Router error catcher for router-caught errors (loaders / non-matched routes)
export const ErrorRouteCatch = () => {
  const error = useRouteError();
  const status = error?.response?.status || error?.status || 0;
  return <ErrorLayout status={status} routerMatchError={status == 0} />;
};

export default ErrorPage;
